import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import { postAgent18 } from "./VipHistoryCRUD";
import { vipHistorySlice } from "./VipHistorySlice";

const { actions } = vipHistorySlice;

export const fetchVipHistory = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));
  dispatch(actions.vipHistoryFetched({ data: null }));

  return postAgent18(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vipHistoryFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchVipHistory");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const fetchVipHistoryDetail = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));
  dispatch(actions.vipHistoryDetailFetched({ data: null }));

  return postAgent18(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vipHistoryDetailFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchVipHistoryDetail");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
